// removed by extract-text-webpack-plugin
module.exports = {"component":"_3ahPtpOIfSIPk8CyFY_8ka"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Hotsite/OneClickBuy/oneClickBuy.css
// module id = 1232
// module chunks = 2